import { MetricsNodeModel } from "./MetricsNodeModel";
import { MetricsPortModel } from "./MetricsPortModel";

export function queryGraph(node: MetricsNodeModel, str: string): MetricsNodeModel | MetricsPortModel | undefined | null {

    if (node) {
        let result = GDS(str);
        if (result) {
            if (result.head) {
                if (result.break) {
                    let op = break_op(result.break);
                    let target_port = break_target_port(result.break)
                    let port = node.getPortByName(result.head, op, target_port);
                    let otherPort = !target_port ? port?.getOtherPort() : port;
                    let otherNode = otherPort?.getNode() as MetricsNodeModel;
                    if (result.tail && result.tail.trim()) {
                        return queryGraph(otherNode, result.tail);
                    }
                    else {
                        return otherNode;
                    }
                }
                else {
                    let port = node.getPortByName(result.head);
                    if (result.tail && result.tail.trim()) {
                        console.warn('tails should not come immediately after heads.')
                        return null;
                    }
                    else {
                        return port;
                    }
                }
            }
        }
    }

    return undefined;
}
export function GDS(str: string) {
    const regex = /(?<head>[a-zA-Z0-9_\- \[\]]*)(?<break>([\<\>a-zA-Z0-9_\-*)\|])*)?(?<tail>[a-zA-Z0-9 \>\<\|\[\]]*)/gm;
    // const str = `Prpoe >| ANOTHERpROPERTY <| ASDF[2]`;
    let m;
    let result: GDS_RESULT = {}
    while ((m = regex.exec(str)) !== null) {
        // This is necessary to avoid infinite loops with zero-width matches
        if (m.index === regex.lastIndex) {
            regex.lastIndex++;
        }

        // The result can be accessed through the `m`-variable.
        if (m?.groups?.head) {
            result.head = m?.groups?.head.trim();
            if (m?.groups?.break) {
                result.break = m?.groups?.break.trim();
                if (m?.groups?.tail) {
                    result.tail = m?.groups?.tail.trim();
                }
            }
            return result;
        }
    }
    return result;
}
export function break_op(str: string): GDS_BREAK {
    const regex = /(?<in>(\<(?<portname>[a-zA-Z0-9_\-]*)\|))|(?<out>(\>(?<portnameout>[a-zA-Z0-9_\-]*)\|))|(?<exit>(\|))/gm;
    let m;

    while ((m = regex.exec(str)) !== null) {
        // This is necessary to avoid infinite loops with zero-width matches
        if (m.index === regex.lastIndex) {
            regex.lastIndex++;
        }
        if (m?.groups?.in) {
            return GDS_BREAK.IN;
        }
        if (m?.groups?.out) {
            return GDS_BREAK.OUT;
        }
        if (m?.groups?.exit) {
            return GDS_BREAK.EXIT;
        }
        // The result can be accessed through the `m`-variable.

    }
    return GDS_BREAK.EXIT;
}
export function break_target_port(str: string): string | undefined {
    const regex = /(?<in>(\<(?<portname>[a-zA-Z0-9_\-]*)\|))|(?<out>(\>(?<portnameout>[a-zA-Z0-9_\-]*)\|))|(?<exit>(\|))/gm;
    let m;

    while ((m = regex.exec(str)) !== null) {
        // This is necessary to avoid infinite loops with zero-width matches
        if (m.index === regex.lastIndex) {
            regex.lastIndex++;
        }
        if (m?.groups?.in && m?.groups?.portname) {
            return m?.groups?.portname.trim();
        }
        if (m?.groups?.out) {
            return m?.groups?.portnameout.trim();
        }
        // The result can be accessed through the `m`-variable.

    }
    return undefined;
}
export enum GDS_BREAK {
    IN = 'IN',
    OUT = 'OUT',
    EXIT = 'EXIT'
}
export interface GDS_RESULT {
    head?: string;
    break?: string;
    tail?: string;
}